<template>
  <div v-bem="{rtl: $i18n.locale === 'ar'}" class="container">
    <div class="row" v-if="options.length > 0">
      <div class="col-6 col-m-6"><h1>{{$t('steps.equipment.options')}} :</h1></div>
      <!-- <div class="col-6 col-m-6 text-right">
        <select name="sort" v-model="sort">
          <option value="ascendant">Prix par ordre ascendant</option>
          <option value="descendant">Prix par ordre descendant</option>
        </select>
      </div> -->
    </div>
    <Loader v-if="!options" />
    <div v-if="options.length > 0" v-bem:list class="row">
      <div
        v-bem:list:item
        class="col-6"
        v-for="option in sortItems(options)"
        :key="option.id"
      >
        <div class="row">
          <div class="col-6">
            <img :src="option.photo" :alt="option.nompack">
            <!-- <p v-bem:ref>Réf. {{option.id}}</p> -->
          </div>
          <div class="col-6">
            <div class="text">
              <p v-bem:name>{{option.nompack}}</p>
              <p v-bem:price>{{priceFormat(option.prix)}} <sub>MAD</sub></p>
              <div v-bem:btn="{selected: option.selected}" @click="selectOption(option.id)"><span>{{$t('cta.select')}}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="accessories.length > 0">
      <div class="col-6 col-m-6"><h1>{{$t('steps.recap.accessories')}} :</h1></div>
      <!-- <div class="col-6 col-m-6 text-right">
        <select name="sort" v-model="sort">
          <option value="ascendant">Prix par ordre ascendant</option>
          <option value="descendant">Prix par ordre descendant</option>
        </select>
      </div> -->
    </div>
    <Loader v-if="!accessories" />
    <div v-if="accessories.length > 0" v-bem:list class="row">
      <div
        v-bem:list:item
        class="col-6"
        v-for="accessorie in sortItems(accessories)"
        :key="accessorie.id"
      >
        <div class="row">
          <div class="col-6">
            <img :src="accessorie.photo" :alt="accessorie.nompack">
            <!-- <p v-bem:ref>Réf. {{accessorie.id}}</p> -->
          </div>
          <div class="col-6">
            <div class="text">
              <p v-bem:name>{{accessorie.nompack}}</p>
              <p v-bem:price>{{priceFormat(accessorie.prix)}} <sub>MAD</sub></p>
              <div v-bem:btn="{selected: accessorie.selected}" @click="selectAccessorie(accessorie.id)"><span>{{$t('cta.select')}}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-6 col-m-6"><h1>Options :</h1></div>
      <div class="col-6 col-m-6 text-right">
        <select name="sort" v-model="sort">
          <option value="ascendant">Prix par ordre ascendant</option>
          <option value="descendant">Prix par ordre descendant</option>
        </select>
      </div>
    </div>
    <div v-bem:list class="row">
      <div
        v-bem:list:item
        class="col-6"
        v-for="accessorie in sortItems(accessories)"
        :key="accessorie.id"
      >
        <div class="row">
          <div class="col-6">
            <img src="@/assets/img/acc1.jpg" :alt="accessorie.name">
            <p v-bem:ref>Réf. {{accessorie.id}}</p>
          </div>
          <div class="col-6">
            <div class="text">
              <p v-bem:name>{{accessorie.name}}</p>
              <p v-bem:price>{{priceFormat(accessorie.price)}} <sub>MAD</sub></p>
              <div v-bem:btn="{selected: accessorie.selected}" @click="select(accessorie.id)"><span>CHOISIR</span></div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="text-center">
      <button class="button button--primary" @click="$emit('next-step')"><span class="button__text">{{$t('cta.finish-order')}}</span></button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Accessories',
  components: {
    Loader: () => import('@/components/Loader.vue')
  },
  data: () => ({
    sort: 'ascendant',
    options: false,
    accessories: false
  }),
  methods: {
    sortItems(items) {
      return [...items].sort((a, b) => this.sort === 'ascendant' ? a.prix - b.prix : b.prix - a.prix)
    },
    selectOption(id) {
      this.options.forEach(opt => {
        if (opt.id === id) {
          this.$store.commit(`${!opt.selected ? 'add' : 'remove'}Option`, !opt.selected ? opt : opt.id);
          opt.selected = !opt.selected;
          return true;
        }
      });
    },
    selectAccessorie(id) {
      this.accessories.forEach(acc => {
        if (acc.id === id) {
          this.$store.commit(`${!acc.selected ? 'add' : 'remove'}Accessorie`, !acc.selected ? acc : acc.id);
          acc.selected = !acc.selected;
          return true;
        }
      });
    }
  },
  created() {
    const model = this.$store.state.models.find(model => model.id_simulateur_modele === this.$store.state.selected.model);
    const version = model.voitures.find(version => version.id_simulateur === this.$store.state.selected.version.id);
    try {
      axios.get('https://www.succursalesrenault.ma/onlinestore/admin/public/api/packs')
        .then(({data}) => data.filter(item => item.voiture === parseInt(version.id)))
        .then(packs => {
          const accs = this.$store.state.selected.accessories;
          this.accessories = packs.map(pack => {
            let selected = false;
            if (accs.length) {
              accs.forEach(acc => {
                selected = acc.id === pack.id;
              });
            }
            return {...pack, selected}
          })
        })
      axios.get('https://www.succursalesrenault.ma/onlinestore/admin/public/api/options')
        .then(({data}) => data.filter(item => item.voiture === parseInt(version.id)))
        .then(options => {
          const opts = this.$store.state.selected.options;
          this.options = options.map(option => {
            let selected = false;
            if (opts.length) {
              opts.forEach(opt => {
                selected = opt.id === option.id;
              });
            }
            return {...option, selected}
          })
        })
    }
    catch (err) { console.error(err) }
  }
}
</script>

<style scoped lang="scss">
.accessories {
  max-width: rem(1000);
  margin: 0 auto;
  select {
    appearance: none;
    background-color: $gray;
    border: rem(1) solid darken($gray, 5%);
    padding: rem(18) rem(25) rem(18) rem(10);
    background-image: url(../../assets/img/icons/sort.svg);
    background-repeat: no-repeat;
    background-position: 95% 50%;
    background-size: rem(10);
  }
  &__list {
    margin: rem(30) auto;
    &-item {
      margin: rem(10) 0;
      .text {
        padding: 0 rem(10);
      }
    }
  }
  &__name {
    font-family: var(--primary-font-bold);
    line-height: 2;
  }
  &__price {
    font-family: var(--primary-font-bold);
    color: rgba(var(--primary-color), 1);
    @include font-size(28);
    margin: rem(20) 0;
    sub {
      @include font-size(12);
      color: $black;
      vertical-align: initial;
    }
  }
  &__ref {
    @include font-size(10);
    font-family: var(--primary-font-light);
    font-weight: 300;
    margin-top: rem(5);
  }
  &__btn {
    position: relative;
    display: inline-block;
    background-color: rgba(var(--primary-color), 1);
    font-family: var(--primary-font-bold);
    padding: rem(6) rem(16);
    @include font-size(14);
    cursor: pointer;
    border: rem(1) solid transparent;
    &:hover {
      background-color: var(--primary-color-hover);
    }
    span {
      color: $white;
      &::before {
        content: "+";
        margin-right: rem(2);
      }
    }
    &--selected {
      background-color: $white;
      border-color: rgba(var(--primary-color), 1);
      span {
        color: $main-color;
        &::before {
          content: "\2713";
        }
      }
      &::after {
        content: "\2715";
        position: absolute;
        top: rem(-1);
        right: 0;
        transform: translateX(100%);
        background-color: rgba(var(--primary-color), 1);
        padding: rem(6) rem(10);
        font-family: var(--primary-font);
        border: rem(1) solid rgba(var(--primary-color), 1);
      }
      &:hover {
          background-color: $white;
        &::after {
          background-color: var(--primary-color-hover);
        }
      }
    }
  }
  &--rtl {
    .accessories__name {
      font-family: var(--primary-font-bold) !important;
    }
    .accessories__price {
      direction: ltr;
      text-align: right;
    }
    .accessories__btn {
      &--selected {
        &::after {
          padding: rem(7.5) rem(10);
          left: rem(-66);
          right: initial;
        }
      }
    }
  }
  @include breakpoint('charmander') {
    margin-top: rem(20);
    select {
      @include font-size(12);
      padding: rem(12) rem(20) rem(12) rem(10);
    }
    h1 {
      @include font-size(24);
      padding-top: rem(4);
    }
    &__list {
      .text {
        padding-left: 0;
      }
    }
    &__price {
      margin: 0 0 rem(10);
    }
    &__btn {
      padding: rem(10) rem(30);
      @include font-size(18);
      &--selected {
        &::after {
          padding: rem(10) rem(10);
        }
      }
    }
    &--rtl {
      .accessories__btn {
        &--selected {
          &::after {
            padding: rem(13);
            left: rem(-84);
          }
        }
      }
    }
  }
}
</style>
